<template>
  <div
    v-if="
      globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_ReadAll') &&
      globals.currentUserRole == 3
    "
  >
    <ConfirmationDialog
      :dialogId="'openSurveyConfirmationModal'"
      :confirmationTitle="lang.SL0018"
      :showDialog="showConfirmationDialog"
      :yesButtonDisable="
        !languageChoosen || (!locationChoosen && hasLocationDummy)
      "
      :yesButtonText="lang.SL0019"
      :noButtonText="lang.SL0020"
      @dialogClosed="onConfirmationDialogClosed"
      @onYesConfirmation="onYesConfirmation"
    >
      <div id="confirmation-table">
        <table class="table table-striped" v-if="selectedSurveyInstance">
          <tbody>
            <tr>
              <td>{{ lang.SL0000 }}</td>
              <td>{{ selectedSurveyInstanceId }}</td>
            </tr>
            <tr>
              <td>{{ lang.SL0025 }}</td>
              <td>
                {{ selectedSurveyInstance.SurveyTitle }}
              </td>
            </tr>
            <tr>
              <td>{{ lang.SL0016 }}</td>
              <td>
                {{ selectedSurveyInstance.LocationName }}
              </td>
            </tr>

            <tr v-if="hasLocationDummy">
              <td>Select Location</td>
              <td>
                <div class="form-group">
                  <select2
                    class="form-control m-0"
                    id="select-location"
                    v-model="selectedLocation"
                    :placeholder="placeholderSelectLocation"
                    :allowClear="true"
                    @change="chooseLocation"
                  >
                    <option></option>
                    <option
                      v-for="location in possibleLocations"
                      :key="location.LocationGuid"
                      :value="location.LocationGuid"
                    >
                      ({{ location.LocationStoreId }})
                      {{ location.LocationAddress }}
                    </option>
                  </select2>
                </div>
              </td>
            </tr>

            <tr>
              <td>{{ lang.SL0007 }}</td>
              <td>
                {{ selectedSurveyInstance.LocationAddress }}
              </td>
            </tr>
            <tr>
              <td>{{ lang.SL0013 }}</td>
              <td>
                {{ selectedSurveyInstance.ScenarioName }}
              </td>
            </tr>
            <tr>
              <td>{{ lang.SL0014 }}</td>
              <td>{{ selectedSurveyInstance.WaveName }}</td>
            </tr>
            <tr v-if="selectedSurveyInstance.SurveyInstanceInfo">
              <td>{{ lang.SL0039 }}</td>
              <td>
                {{ selectedSurveyInstance.SurveyInstanceInfo }}
              </td>
            </tr>
            <tr>
              <td>{{ lang.SL0041 }}</td>
              <td>
                {{ selectedSurveyInstance.SurveyInstanceSince }}
              </td>
            </tr>
            <tr
              :class="{
                'text-red': selectedSurveyInstance.SurveyInstanceIsExpired,
              }"
            >
              <td>{{ lang.SL0038 }}</td>
              <td>
                {{ selectedSurveyInstance.SurveyInstanceUntil }}
              </td>
            </tr>
            <tr>
              <td>{{ lang.SL0015 }}</td>
              <td v-html="selectedSurveyInstance.LocationAdditionalInfo"></td>
            </tr>
            <tr
              v-if="
                selectedSurveyInstance.SurveyInstanceTotalPayment &&
                !globals.isSurveyCodeUser
              "
            >
              <td>{{ lang.SL0037 }}</td>
              <td>
                {{
                  globals.getCurrencyString(
                    selectedSurveyInstance.SurveyInstanceTotalPayment,
                    "EUR"
                  )
                }}
              </td>
            </tr>
            <tr v-if="selectedSurveyInstance.SurveyInstanceShopperSubmittedAt">
              <td>{{ lang.SL0032 }}</td>
              <td>
                {{ selectedSurveyInstance.SurveyInstanceShopperSubmittedAt }}
              </td>
            </tr>
            <tr
              v-if="
                selectedSurveyInstance.BriefingDownload &&
                selectedSurveyInstance.BriefingDownload.Guid
              "
            >
              <td>{{ lang.SL0035 }}</td>
              <td>
                <a
                  @click="
                    donwloadBriefing(
                      selectedSurveyInstance.BriefingDownload.Guid,
                      selectedSurveyInstance.BriefingDownload.FileName
                    )
                  "
                  >{{ selectedSurveyInstance.BriefingDownload.FileName }}</a
                >
              </td>
            </tr>
            <tr
              v-if="
                selectedSurveyInstance.SurveyDownload &&
                selectedSurveyInstance.SurveyDownload.Guid
              "
            >
              <td>{{ lang.SL0036 }}</td>
              <td>
                <a
                  @click="
                    downloadSurveyDownload(
                      selectedSurveyInstance.SurveyDownload.Guid,
                      selectedSurveyInstance.SurveyDownload.FileName
                    )
                  "
                  >{{ selectedSurveyInstance.SurveyDownload.FileName }}</a
                >
              </td>
            </tr>
            <tr>
              <td>{{ lang.SL0001 }}</td>
              <td>
                <div class="form-group">
                  <select2
                    class="form-control nopadding"
                    id="selectLanguage"
                    v-model="selectedSurveyInstanceAnswerLanguage"
                    @change="chooseSurveyLanguage()"
                  >
                    <option disabled value>{{ lang.SL0002 }}</option>
                    <option
                      v-for="language in surveyInstanceAnswerLanguageList"
                      :key="language.LocaleCode"
                      :value="language.LocaleCode"
                      :selected="
                        selectedSurveyInstanceAnswerLanguage ===
                        language.LocaleCode
                      "
                    >
                      {{ language.LocaleName }}
                    </option>
                  </select2>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ConfirmationDialog>

    <div class="panel panel-default" v-if="!showSurvey" id="survey-top-panel">
      <div class="panel-body">
        <div class="col-md-12">
          <!-- Add buttons here  -->
          <button
            class="btn btn-raised btn-top-bar"
            :disabled="!refreshEnabled"
            @click="getAllSurveyInstancesAnswers()"
          >
            <i class="material-icons md-36">refresh</i>
            <template v-if="!isSmallScreen">
              <br />
              {{ lang.SL0009 }}
            </template>
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            @click="openSelectedSurveyInstance()"
            :disabled="
              !globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_Read') ||
              selectedSurveyInstanceId < 0
            "
          >
            <i class="material-icons md-36">open_in_browser</i>
            <template v-if="!isSmallScreen">
              <br />
              {{ lang.SL0010 }}
            </template>
          </button>
          <!-- <button class="btn btn-raised btn-top-bar" @click="submitSelectedSurveyInstance()">
          <i class="material-icons md-36">refresh</i><br>{{lang.SL0011}}</button>-->
        </div>
      </div>
      <div class="panel-body">
        <div class="col-xs-6">
          <!-- Searchbar - triggered by enter key -->
          <div class="form-group searchbar">
            <input
              type="search"
              class="form-control"
              id="inputSearch"
              :placeholder="lang.SL0012"
              v-model="searchString"
              @input="doDebouncedFiltering()"
            />
          </div>
        </div>
        <div class="col-xs-6" v-if="isSmallScreen">
          <!-- Searchbar - triggered by enter key -->
          <div class="form-group searchbar">
            <select
              class="form-control"
              v-model="filters.SurveyInstanceStatusId"
              @change="doFiltering()"
            >
              <option value hidden>{{ lang.SL0033 }}</option>
              <option value>{{ lang.SL0034 }}</option>
              <option value="100">{{ lang.SL0028 }}</option>
              <option value="110">{{ lang.SL0029 }}</option>
              <option value="120">{{ lang.SL0030 }}</option>
              <option value="130">{{ lang.SL0031 }}</option>
            </select>
          </div>
        </div>
        <div class="col-lg-6 col-xs-12 nopadding">
          <!-- Pagination -->
          <ul class="pagination-fonts pagination btn-group">
            <li>
              <!-- Dropdown: Select the number of elements per page -->
              <a
                role="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                id="elementsPerPageDropdown"
              >
                <i class="material-icons md-18">view_headline</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="elementsPerPageDropdown"
                :delay="globals.tooltipDelay"
                >{{ lang.SL0021 }}</b-tooltip
              >
              <ul class="dropdown-menu">
                <!-- Add dropdown entries here -->
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 20 }"
                    role="button"
                    @click="updatePaging(1, 20)"
                    >20</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 50 }"
                    role="button"
                    @click="updatePaging(1, 50)"
                    >50</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 100 }"
                    role="button"
                    @click="updatePaging(1, 100)"
                    >100</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 200 }"
                    role="button"
                    @click="updatePaging(1, 200)"
                    >200</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 500 }"
                    role="button"
                    @click="updatePaging(1, 500)"
                    >500</a
                  >
                </li>
              </ul>
            </li>

            <!-- Jump to first page -->
            <li
              v-bind:class="{ disabled: selectedPage == 1 }"
              @click="updatePaging(1, 0)"
            >
              <a role="button" id="firstPageButton">
                <i class="material-icons md-18">first_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="firstPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.SL0022 }}</b-tooltip
              >
            </li>
            <!-- ... -->
            <li v-if="numberOfPages() > 7 && selectedPage > 4" class="disabled">
              <a role="button">...</a>
            </li>
            <!-- Pagenumbers -->
            <li
              v-for="pageNumber in getVisiblePages()"
              :key="pageNumber"
              v-bind:class="{ active: selectedPage == pageNumber }"
              @click="updatePaging(pageNumber, 0)"
            >
              <a role="button">{{ pageNumber }}</a>
            </li>
            <!-- ... -->
            <li
              v-if="numberOfPages() > 7 && selectedPage < numberOfPages() - 3"
              class="disabled"
            >
              <a role="button">...</a>
            </li>
            <!-- Jump to last page -->
            <li
              v-bind:class="{ disabled: selectedPage == numberOfPages() }"
              @click="updatePaging(numberOfPages(), 0)"
            >
              <a role="button" id="lastPageButton">
                <i class="material-icons md-18">last_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="lastPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.SL0023 }}</b-tooltip
              >
            </li>
            <li class="disabled">
              <a role="button" id="checksTotalElementsCounter">{{
                filteredSurveyListData.length
              }}</a>
              <b-tooltip
                ref="tooltip"
                target="checksTotalElementsCounter"
                :delay="globals.tooltipDelay"
                >{{ lang.SL0040 }}</b-tooltip
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="panel panel-default" id="survey">
      <div class="panel-body">
        <!-- override class stylings with id stylings [#1277] -->
        <table
          id="the-table"
          class="table table-striped table-hover main-table"
        >
          <thead>
            <tr>
              <th class="text-center sticky-header">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableCell('SurveyInstanceStatusId')"
                  >{{ lang.SL0003 }}
                  <span
                    v-if="showSortArrow('SurveyInstanceStatusId', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('SurveyInstanceStatusId', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th class="text-center sticky-header">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableCell('SurveyTitle')"
                >
                  {{ isSmallScreen ? lang.SL0025 : lang.SL0004 }}
                  <span
                    v-if="showSortArrow('SurveyTitle', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('SurveyTitle', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th
                class="text-center sticky-header"
                :class="{ hidden: isSmallScreen }"
              >
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableCell('SurveyInstanceId')"
                  >{{ lang.SL0005 }}
                  <span
                    v-if="showSortArrow('SurveyInstanceId', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('SurveyInstanceId', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th class="text-center sticky-header">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableCell('LocationName')"
                  >{{ isSmallScreen ? lang.SL0024 : lang.SL0016 }}
                  <span
                    v-if="showSortArrow('LocationName', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('LocationName', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th class="text-center sticky-header">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableCell('LocationAddress')"
                  >{{ lang.SL0007 }}
                  <span
                    v-if="showSortArrow('LocationAddress', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('LocationAddress', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th class="text-center sticky-header">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableCell('ScenarioName')"
                  >{{ lang.SL0013 }}
                  <span
                    v-if="showSortArrow('ScenarioName', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('ScenarioName', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th
                class="text-center sticky-header"
                :class="{ hidden: isSmallScreen }"
              >
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableCell('WaveName')"
                  >{{ lang.SL0014 }}
                  <span
                    v-if="showSortArrow('WaveName', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('WaveName', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th
                class="text-center sticky-header"
                :class="{ hidden: isSmallScreen }"
              >
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableCell('SurveyInstanceInfo')"
                  >{{ lang.SL0039 }}
                  <span
                    v-if="showSortArrow('SurveyInstanceInfo', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('SurveyInstanceInfo', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th
                class="text-center sticky-header"
                :class="{ hidden: isSmallScreen }"
              >
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableCell('LocationAdditionalInfo')"
                  >{{ isSmallScreen ? lang.SL0026 : lang.SL0015 }}
                  <span
                    v-if="showSortArrow('LocationAdditionalInfo', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('LocationAdditionalInfo', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th
                class="text-center sticky-header"
                :class="{ hidden: isSmallScreen || globals.isSurveyCodeUser }"
              >
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableCell('SurveyInstanceTotalPayment')"
                  >{{ lang.SL0037 }}
                  <span
                    v-if="showSortArrow('SurveyInstanceTotalPayment', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('SurveyInstanceTotalPayment', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th class="text-center sticky-header">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableCell('SurveyInstanceProgress')"
                  >{{ lang.SL0008 }}
                  <span
                    v-if="showSortArrow('SurveyInstanceProgress', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('SurveyInstanceProgress', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th
                class="text-center sticky-header"
                :class="{ hidden: isSmallScreen }"
              >
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableCell('SurveyInstanceShopperSubmittedAt')"
                  >{{ lang.SL0032 }}
                  <span
                    v-if="
                      showSortArrow('SurveyInstanceShopperSubmittedAt', true)
                    "
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="
                      showSortArrow('SurveyInstanceShopperSubmittedAt', false)
                    "
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th
                class="text-center sticky-header"
                :class="{ hidden: isSmallScreen }"
              >
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableCell('SurveyInstanceUntil')"
                  >{{ lang.SL0038 }}
                  <span
                    v-if="showSortArrow('SurveyInstanceUntil', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('SurveyInstanceUntil', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
            </tr>
            <tr v-if="globals.isLargeScreen()" class="table-filters">
              <th class="nopadding sticky-filter">
                <div
                  class="form-group filterbar"
                  id="surveyListStatusFilterContainer"
                >
                  <select2
                    class="form-control nopadding"
                    id="surveyListStatusFilterSelect"
                    v-model="filters.SurveyInstanceStatusId"
                    :allowClear="true"
                    :placeholder="lang.SL0027"
                    @change="doFiltering()"
                    @open="surveyListStatusFilterSelectOpened()"
                  >
                    <option></option>
                    <option :value="100">{{ lang.SL0028 }}</option>
                    <option :value="110">{{ lang.SL0029 }}</option>
                    <option :value="120">{{ lang.SL0030 }}</option>
                    <option :value="130">{{ lang.SL0031 }}</option>
                  </select2>
                </div>
              </th>
              <th class="nopadding sticky-filter">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SL0027"
                    v-model="filters.SurveyTitle"
                    @input="doDebouncedFiltering()"
                  />
                </div>
              </th>
              <th class="nopadding sticky-filter">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SL0027"
                    v-model="filters.SurveyInstanceId"
                    @input="doDebouncedFiltering()"
                  />
                </div>
              </th>
              <th class="nopadding sticky-filter">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SL0027"
                    v-model="filters.LocationName"
                    @input="doDebouncedFiltering()"
                  />
                </div>
              </th>
              <th class="nopadding sticky-filter">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SL0027"
                    v-model="filters.LocationAddress"
                    @input="doDebouncedFiltering()"
                  />
                </div>
              </th>
              <th class="nopadding sticky-filter">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SL0027"
                    v-model="filters.ScenarioName"
                    @input="doDebouncedFiltering()"
                  />
                </div>
              </th>
              <th class="nopadding sticky-filter">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SL0027"
                    v-model="filters.WaveName"
                    @input="doDebouncedFiltering()"
                  />
                </div>
              </th>
              <th class="nopadding sticky-filter">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SL0027"
                    v-model="filters.SurveyInstanceInfo"
                    @input="doDebouncedFiltering()"
                  />
                </div>
              </th>
              <th class="nopadding sticky-filter">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SL0027"
                    v-model="filters.LocationAdditionalInfo"
                    @input="doDebouncedFiltering()"
                  />
                </div>
              </th>
              <th
                class="nopadding sticky-filter"
                v-show="!globals.isSurveyCodeUser"
              >
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SL0027"
                    v-model="filters.SurveyInstanceTotalPayment"
                    @input="doDebouncedFiltering()"
                  />
                </div>
              </th>
              <th class="nopadding sticky-filter">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SL0027"
                    v-model="filters.SurveyInstanceProgress"
                    @input="doDebouncedFiltering()"
                  />
                </div>
              </th>
              <th class="nopadding sticky-filter">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SL0027"
                    v-model="filters.SurveyInstanceShopperSubmittedAt"
                    @input="doDebouncedFiltering()"
                  />
                </div>
              </th>
              <th class="nopadding sticky-filter">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SL0027"
                    v-model="filters.SurveyInstanceUntil"
                    @input="doDebouncedFiltering()"
                  />
                </div>
              </th>
            </tr>
          </thead>
          <tbody class="main-table-scrollbar">
            <tr
              role="button"
              :key="survey.SurveyInstanceId"
              @click="
                (selectedSurveyInstanceId = survey.SurveyInstanceId),
                  (selectedSurveyInstance = survey)
              "
              @dblclick="
                !globals.isAccessAllowed(
                  'LoopOp_SurveyInstancesAnswers_Read'
                ) || openSelectedSurveyInstance()
              "
              :class="{
                info: survey.SurveyInstanceId === selectedSurveyInstanceId,
                'text-red': survey.SurveyInstanceIsExpired,
                'text-grey': survey.SurveyInstanceIsInactive,
              }"
              class="text-center"
              v-for="survey in surveysOnCurrentPage"
            >
              <td id="materialIconCell">
                <i
                  class="material-icons md-24"
                  v-if="survey.SurveyInstanceStatusId == 100"
                  >add_circle_outline</i
                >
                <i
                  class="material-icons md-24"
                  v-if="survey.SurveyInstanceStatusId == 110"
                  >autorenew</i
                >
                <i
                  class="material-icons md-24"
                  v-if="survey.SurveyInstanceStatusId == 120"
                  >check_circle</i
                >
                <i
                  class="material-icons md-24"
                  v-if="survey.SurveyInstanceStatusId == 130"
                  >help_outline</i
                >
              </td>
              <td>
                <span class="word-break">{{ survey.SurveyTitle }}</span>
              </td>
              <td :class="{ hidden: isSmallScreen }">
                <span>{{ survey.SurveyInstanceId }}</span>
              </td>
              <td>
                <span>{{ survey.LocationName }}</span>
              </td>
              <td>
                <span>{{ survey.LocationAddress }}</span>
              </td>
              <td>
                <span>{{ survey.ScenarioName }}</span>
              </td>
              <td :class="{ hidden: isSmallScreen }">
                <span>{{ survey.WaveName }}</span>
              </td>
              <td :class="{ hidden: isSmallScreen }">
                <span>{{ survey.SurveyInstanceInfo }}</span>
              </td>
              <td :class="{ hidden: isSmallScreen }">
                <span class="word-break">
                  {{
                    globals.truncateString(
                      globals.getMarkupText(survey.LocationAdditionalInfo),
                      40
                    )
                  }}</span
                >
              </td>
              <td
                :class="{ hidden: isSmallScreen || globals.isSurveyCodeUser }"
              >
                <span>{{
                  survey.SurveyInstanceTotalPayment
                    ? globals.getCurrencyString(
                        survey.SurveyInstanceTotalPayment,
                        "EUR"
                      )
                    : ""
                }}</span>
              </td>
              <td>
                <span>{{ survey.SurveyInstanceProgress }}%</span>
              </td>
              <td :class="{ hidden: isSmallScreen }">
                <span>{{ survey.SurveyInstanceShopperSubmittedAt }}</span>
              </td>
              <td :class="{ hidden: isSmallScreen }">
                <span>{{ survey.SurveyInstanceUntil }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import ConfirmationDialog from "./../Tools/Dialogs/ConfirmationDialog";
import Select2 from "../Tools/Select2";

export default {
  name: "SurveyList",
  components: {
    ConfirmationDialog,
    Select2,
  },
  data() {
    return {
      showConfirmationDialog: false,
      locationChoosen: false,
      languageChoosen: false,
      possibleLocations: [],
      placeholderSelectLocation: { id: "0", text: "Please select an entry..." },
      allSurveyInstancesAnswersData: [],
      selectedLocation: null,
      selectedSurveyInstanceId: -1,
      selectedSurveyInstance: null,
      surveyInstanceAnswerData: null,
      surveyInstanceAnswerLanguageList: [],
      selectedSurveyInstanceAnswerLanguage: "",
      selectedSurveyDisplayOnlyMode: false,
      showSurvey: false,
      filteredSurveyListData: [],
      searchString: "",
      filters: {
        SurveyInstanceStatusId: "",
        SurveyTitle: "",
        SurveyInstanceId: "",
        LocationName: "",
        LocationAddress: "",
        ScenarioName: "",
        WaveName: "",
        SurveyInstanceInfo: "",
        LocationAdditionalInfo: "",
        SurveyInstanceProgress: "",
        SurveyInstanceShopperSubmittedAt: "",
      },
      refreshEnabled: false, // false, if client data is requested and server did not respond yet to avoid multiple requests at the same time
      surveysOnCurrentPage: [],
      pageSize: 20, // Number of projects on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      debouncedFilterFunction: null,
      lang: {
        SL0000: "SurveyInstanceID",
        SL0001: "Language",
        SL0002: "Please choose...",
        SL0003: "Status",
        SL0004: "Project",
        SL0005: "SurveyInstanceID",
        SL0006: "StoreID",
        SL0007: "Address",
        SL0008: "Progress",
        SL0009: "Refresh",
        SL0010: "Open",
        SL0011: "Submit",
        SL0012: "Search...",
        SL0013: "Scenario Name",
        SL0014: "Wave Name",
        SL0015: "Location Info",
        SL0016: "Location Name",
        SL0017: "Display only mode",
        SL0018: "Open survey",
        SL0019: "Open",
        SL0020: "Cancel",
        SL0021: "Items per page",
        SL0022: "First page",
        SL0023: "Last page",
        SL0024: "Where?",
        SL0025: "Project",
        SL0026: "Info",
        SL0027: "Filter",
        SL0028: "New",
        SL0029: "In progress",
        SL0030: "Submitted",
        SL0031: "Query",
        SL0032: "Submitted At",
        SL0033: "Status...",
        SL0034: "All",
        SL0035: "Briefing",
        SL0036: "Survey",
        SL0037: "Payment",
        SL0038: "Expiry Date",
        SL0039: "Check Info",
        SL0040: "Total check count",
        SL0041: "Start Date",
        SL0042: "Start Date",
        SL0043: "Please enable Pop-ups for this application",
        SL0044: "Please select a language",
        G00025: "File download failed",
      },
      currentSort: { key: "SurveyInstanceStatusId", asc: true },
      isSmallScreen: false,
    };
  },
  mounted() {
    if (this.$router.currentRoute.query.newLogin) {
      this.$appService.removeTokensFromStorage();
      delete this.$router.currentRoute.query.newLogin;
    }
    if (this.globals.selectedLanguage) {
      this.getAllSurveyInstancesAnswers();
      this.globals.getLanguageStrings(this, this.setElementHeights);
    }

    if (!this.globals.currentUserInfo)
      this.globals.$once("currentUserInfoReceived", this.setElementHeights);

    // Sets the new table height after the window got resized
    let resizeFunc = () => {
      this.isSmallScreen = this.globals.isSmallScreen();
      this.$nextTick(() => {
        this.setElementHeights();
        this.$forceUpdate();
      });
    };
    $(window).off("resize", resizeFunc);
    $(window).on("resize", resizeFunc).resize();

    //Old resize function
    /* $(window).on("resize", this.setElementHeights).resize();
    // Sets the new table height after the window got resized
    let resizeFunc = () => {
      this.isSmallScreen = this.globals.isSmallScreen();
      this.$forceUpdate();
    } */ //$(window).off("resize", resizeFunc);

    this.debouncedFilterFunction = _.debounce(this.doFiltering, 500);
  },
  destroyed() {
    $(window).off("resize", this.setElementHeights);
  },
  computed: {
    selectedSurveyInstanceStatusId() {
      if (this.selectedSurveyInstanceId < 0) return -1;
      let surveyInstance = this.allSurveyInstancesAnswersData.filter(
        (s) => s.SurveyInstanceId === this.selectedSurveyInstanceId
      );
      if (surveyInstance && surveyInstance[0])
        return surveyInstance[0].SurveyInstanceStatusId;
      return -1;
    },
    hasLocationDummy() {
      return (
        this.selectedSurveyInstance &&
        this.selectedSurveyInstance.LocationName &&
        this.selectedSurveyInstance.LocationName === "DummyLocation"
      );
    },
  },
  methods: {
    async donwloadBriefing(guid, filename) {
      try {
        await this.globals.downloadFilewithName(guid, filename);
      }
      catch(error)
      {
        this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.G00025, colorOrange: false});
      }
    },
    async downloadSurveyDownload(guid, filename) {
      try {
        await this.globals.downloadFilewithName(guid, filename);
      }
      catch(error)
      {
        this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.G00025, colorOrange: false});
      }
    },
    /**
     * Apply the selected location
     */
    /* applyLocationSelection(surveyObject) {
      if (!this.hasLocationDummy) return;
      let locationObject = _.find(this.possibleLocations, (l) => {
        return l.LocationGuid === this.selectedLocation;
      });
      surveyObject.LocationAddress = locationObject.LocationAddress;
      surveyObject.LocationCountry = locationObject.LocationCountry;
      surveyObject.LocationName = locationObject.LocationName;
      surveyObject.LocationStoreId = locationObject.LocationStoreId;
      surveyObject.LocationId = locationObject.LocationId;
    }, */
    /**
     * Create a new DCA (dynamic check actual) from DCT (dynamic check template)
     * (Or get previously created DCA)
     * @return created SurveyInstanceId
     */
    async createDCASurveyInstance() {
      // just here to prevent developer error
      if (this.selectedSurveyInstance.SurveyInstanceType === "DCT") {
        let locationObject = _.find(this.possibleLocations, (l) => {
          return l.LocationGuid === this.selectedLocation;
        });

        let requestObject = {}
        // only send what is needed
        requestObject.LocationId = locationObject.LocationId;
        requestObject.SurveyInstanceId = this.selectedSurveyInstanceId;

        return new Promise((resolve, reject) => {
          $.ajax({
            method: "POST",
            url: `api/SurveyInstances/CreateDCA`,
            data: JSON.stringify(requestObject),
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            success: (data) => {
              if (data.DCASurveyInstanceId) {
                resolve(data.DCASurveyInstanceId);
              }
              else {
                reject();
              }
            },
            error: () => {
              console.error("Error on POST in createDCASurveyInstance()");
              this.globals.$emit("openGlobalErrorDialog", {errorText: "Location selection failed", colorOrange: false});
              reject();
            },
          });
        });
      }
      else {
        throw new TypeError("Wrong SurveyInstanceType");
      }
    },
    /**
     *  Get selectable locations for the current client
     */
    getLocationsOfSelectedClient() {
      if (!this.selectedSurveyInstance.ClientGuid) {
        this.possibleLocations = [];
        return;
      }

      $.ajax({
        method: "POST",
        url: `api/SurveyInstances/Locations/${this.selectedSurveyInstance.ClientGuid}`,
        success: (data) => {
          if (data[0]) {
            if (data[0].Locations) this.possibleLocations = data[0].Locations;
            else this.possibleLocations = [];
          }
        },
        error: () => {
          console.error("Error on POST in getLocationsOfSelectedClient()");
          this.globals.$emit("openGlobalErrorDialog", {errorText: "Location data access failed", colorOrange: false});
        },
      });
    },

    /*
    setElementHeights() {
      this.$nextTick(() => {
        let height = $(window).height();
        height -=
          $("#checks-top-panel").height() + $("#app-navbar").height() + 47; // 47 pixel for the free space around the cards;

        $(".table-space").css("max-height", height);
        $(".main-table-scrollbar").css("max-height", height);

        //height -= $(".main-table > thead").height();
        //$(".main-table-scrollbar").css("max-height", height);

        height = $(window).height();
        height -= $(".main-table > thead").height() + 390;
        $("#create-checks-table").css("max-height", height);
        height += 85;
        $("#check-list-table").css("max-height", height);
      });
    },

    */

    setElementHeights() {
      let height = $(window).height();

      height -=
        $("#app-navbar").height() * 2.7 +
        $(".main-table > thead").height() +
        47;

      $(".table-space").css("max-height", height);
      $(".main-table-scrollbar").css("max-height", height);
      let table = $(".main-table-scrollbar");
      table.css("max-height", height);

      // Set top for Filter, that it doesent scroll over table-header
      height = $(".main-table thead tr").height();
      $(".sticky-filter").css("top", height);
    },

    /*
     * Operations with the backend
     */
    // if no progress, init progress with 0
    initSurveyInstanceProgress(data) {
      data.forEach((d) => {
        d.SurveyInstanceProgress = d.SurveyInstanceProgress
          ? d.SurveyInstanceProgress
          : 0;
      });
    },
    surveyEditAllowed(check) {
      if (
        _.indexOf([100, 110, 130], check.SurveyInstanceStatusId) > -1 &&
        !check.SurveyInstanceIsInactive
      )
        return true;
      return false;
    },
    // fetch all survey instances answers for table
    getAllSurveyInstancesAnswers() {
      this.refreshEnabled = false;
      let queryString = `api/SurveyInstancesAnswers/?languageCode=${this.globals.selectedLanguage}`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          // this.allSurveyInstancesAnswersData = data;
          // this.filteredSurveyListData = data;
          if (_.isEmpty(data)) {
            this.allSurveyInstancesAnswersData = [];
            this.surveysOnCurrentPage = [];
            return;
          }
          this.initSurveyInstanceProgress(data);
          this.allSurveyInstancesAnswersData = data;

          if (this.selectedSurveyInstanceId > -1)
            this.selectedSurveyInstance = _.find(
              this.allSurveyInstancesAnswersData,
              ["SurveyInstanceId", this.selectedSurveyInstanceId]
            );
          if (!this.selectedSurveyInstance) {
            this.selectedSurveyInstanceId = -1;
            this.selectedSurveyInstance = null;
          }

          this.orderTableCell("");
          this.doFiltering(true);
        },
        error: () => {
          console.error("Error in getAllSurveyInstancesAnswers");
          this.globals.$emit("openGlobalErrorDialog", {errorText: "Survey list request failed", colorOrange: false});
        },
        complete: () => {
          this.refreshEnabled = true;
        },
      });
    },
    // open selected survey instance
    openSelectedSurveyInstance() {
      if (this.selectedSurveyInstanceId > -1) {
        this.selectedSurveyDisplayOnlyMode = !this.surveyEditAllowed(
          this.selectedSurveyInstance
        );
        this.getSurveyInstanceAnswer();
        if (this.hasLocationDummy) {
          this.getLocationsOfSelectedClient();
        }
        this.chooseSurveyLanguage();
        this.showConfirmationDialog = true;
      }
    },
    /**
     * Save SurveyInstance Answer.
     * @param {int} id
     * @return {Promise}
     */
    async putSurvey(id, surveyObject) {
      var queryString = "api/SurveyInstancesAnswers/" + id;
      return new Promise((resolve, reject) => {
        $.ajax({
          method: "PUT",
          url: queryString,
          data: JSON.stringify(surveyObject),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function (data) {
            if (data.Error) {
              reject("Backendmsg:" + data.Error);
            }
            resolve(data);
          },
        });
      });
    },
    /**
     * If we have a Internet Connection,then it will send a req to backend for SurveyInstanceData
     * with id
     * else it will try the internal Storage
     * @param {number} id
     * @param {String} lang
     * @returns {Promise<SurveyInstanceData>}
     */
    async requestSurvey(id, lang) {
      if (!navigator.onLine) {
        return this.getSurveyfromDB_byID(id);
      }
      let queryString =
        "api/SurveyInstancesAnswers/" + id + "?localeCode=" + lang;

      return new Promise((resolve, reject) => {
        $.ajax({
          url: queryString,
          type: "GET",
          success: function (data) {
            if (data.Error) {
              reject(data.Error);
            }
            resolve(data);
          },
          error: function (error) {
            reject(error);
          },
        });
      });
    },
    // fetch the selected surveyinstanceanswer
    getSurveyInstanceAnswer() {
      var surveyInstancesAnswersDataIndex = _.findIndex(
        this.allSurveyInstancesAnswersData,
        (o) => {
          return o.SurveyInstanceId == this.selectedSurveyInstanceId;
        }
      );
      this.surveyInstanceAnswerData =
        this.allSurveyInstancesAnswersData[surveyInstancesAnswersDataIndex];
      if (this.surveyInstanceAnswerData.Languages) {
        this.getSurveyInstanceAnswerDataLanguage();
      } else {
        this.surveyInstanceAnswerLanguageList = [];
        this.selectedSurveyInstanceAnswerLanguage = "";
      }
    },
    // fetch languages for one specific survey instance answer data
    getSurveyInstanceAnswerDataLanguage() {
      this.surveyInstanceAnswerLanguageList = [];
      this.surveyInstanceAnswerData.Languages.forEach((element) => {
        this.surveyInstanceAnswerLanguageList.push({
          LocaleCode: element.LocaleCode,
          LocaleName: element.LocaleName,
        });
      });
      if (this.surveyInstanceAnswerLanguageList.length === 1) {
        this.selectedSurveyInstanceAnswerLanguage =
          this.surveyInstanceAnswerLanguageList[0].LocaleCode;
      } else if (this.surveyInstanceAnswerData.LocaleCode) {
        // LocaleCode fits 100%
        if (
          this.surveyInstanceAnswerLanguageList.includes(
            this.surveyInstanceAnswerData.LocaleCode
          )
        ) {
          this.selectedSurveyInstanceAnswerLanguage =
            this.surveyInstanceAnswerData.LocaleCode;
        } else {
          // LocaleCode fits only in language part for instance 'de-DE' <-> 'de-AU'
          this.surveyInstanceAnswerLanguageList.forEach((lang) => {
            if (
              lang.LocaleCode.split("-")[0] ===
              this.surveyInstanceAnswerData.LocaleCode.split("-")[0]
            )
              this.selectedSurveyInstanceAnswerLanguage = lang.LocaleCode;
          });
        }
      }
    },
    chooseSurveyLanguage() {
      this.languageChoosen = this.selectedSurveyInstanceAnswerLanguage
        ? true
        : false;
    },
    chooseLocation() {
      this.locationChoosen = this.selectedLocation ? true : false;
    },
    /*
     * modal methods
     */
    onConfirmationDialogClosed() {
      this.showConfirmationDialog = false;
      this.selectedSurveyInstanceAnswerLanguage = "";
    },
    onYesConfirmation() {
      if (this.selectedSurveyInstanceAnswerLanguage.length > 0) {
        // If DCT and LocationDummy replaced by selected location generate and show DCA
        if (this.selectedSurveyInstance.SurveyInstanceType === "DCT") {
          this.createDCASurveyInstance()
            .then( (NewSurveyInstanceId) => {
              if (
                  this.selectedSurveyInstanceAnswerLanguage.length > 0 &&
                  NewSurveyInstanceId
              ) 
              {
                this.showConfirmationDialog = false;
                window.name = `MSMLoopShopperApp`;
                let url = `${window.origin}/survey.html#/view/${NewSurveyInstanceId}?lang=${this.selectedSurveyInstanceAnswerLanguage}`;
                if (this.selectedSurveyDisplayOnlyMode) url += `&ro=1`;
                let newWindow = window.open(url);
                if(newWindow) {
                  newWindow.onbeforeunload = () => {
                    this.getAllSurveyInstancesAnswers();
                  };
                  newWindow.openerVueInstance = this;
                }
                else {
                  throw new ReferenceError("Pop-up blocked!");
                }
              }
            })
            .catch((e) => {
              if(e && e.message == "Pop-up blocked!") {
                this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.SL0043, colorOrange: false});
              }
            });

          /* this.requestSurvey(
            this.selectedSurveyInstanceId,
            this.selectedSurveyInstance.LocaleCode
          ).then((surveyData) => {
            this.applyLocationSelection(surveyData);
            this.putSurvey(this.selectedSurveyInstanceId, surveyData).then(
              (data) => {
                if (
                  this.selectedSurveyInstanceAnswerLanguage.length > 0 &&
                  data.NewSurveyInstanceId
                ) {
                  this.showConfirmationDialog = false;
                  window.name = `MSMLoopShopperApp`;
                  let url = `${window.origin}/survey.html#/view/${data.NewSurveyInstanceId}?lang=${this.selectedSurveyInstanceAnswerLanguage}`;
                  if (this.selectedSurveyDisplayOnlyMode) url += `&ro=1`;
                  let newWindow = window.open(url);
                  if(newWindow) {
                    newWindow.onbeforeunload = () => {
                      this.getAllSurveyInstancesAnswers();
                    };
                    newWindow.openerVueInstance = this;
                  }
                  else {
                    throw new ReferenceError("Pop-up blocked!");
                  }
                }
              }
            ).catch( e =>
              this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.SL0043, colorOrange: false});
            );
          }); */
        }
        else {
          this.showConfirmationDialog = false;
          window.name = `MSMLoopShopperApp`;
          let url = `${window.origin}/survey.html#/view/${this.selectedSurveyInstanceId}?lang=${this.selectedSurveyInstanceAnswerLanguage}`;
          if (this.selectedSurveyDisplayOnlyMode) url += `&ro=1`;
          let newWindow = window.open(url);
          if(newWindow) {
            newWindow.onbeforeunload = () => {
              this.getAllSurveyInstancesAnswers();
            };
            newWindow.openerVueInstance = this;
          }
          else {
            this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.SL0043, colorOrange: false});
          }
        }
      }
      else {
        this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.SL0044, colorOrange: false});
      }
    },
    /*
     * table sorting
     */
    showSortArrow(key, asc) {
      return this.currentSort.key === key && this.currentSort.asc === asc;
    },
    orderTableCell(orderProp) {
      // Nothing to sort by => return
      if (orderProp === "" && this.currentSort.key === "") return;

      if (orderProp !== "") {
        this.currentSort.key === orderProp
          ? (this.currentSort.asc = !this.currentSort.asc)
          : (this.currentSort = { asc: true, key: orderProp });
      }

      const sortFunction = (survey) => {
        if (typeof survey[this.currentSort.key] === "string") {
          return survey[this.currentSort.key].toLowerCase();
        }
        if (this.currentSort.key === "SurveyInstanceStatusId") {
          if (survey[this.currentSort.key] === 100) return 110;
          if (survey[this.currentSort.key] === 110) return 100;
        }
        return survey[this.currentSort.key];
      };
      this.filteredSurveyListData = _.orderBy(
        this.filteredSurveyListData,
        [sortFunction],
        [this.currentSort.asc ? "asc" : "desc", "asc"]
      );
      this.loadCurrentPageOfSurveys();
    },
    doDebouncedFiltering() {
      if (this.debouncedFilterFunction) this.debouncedFilterFunction();
    },
    doFiltering(keepPage) {
      var words = this.searchString.split(" ");
      let keys = Object.keys(this.filters);

      const surveyFilter = (survey) => {
        let containsSearch = false;
        words.forEach((word) => {
          keys.forEach((key) => {
            if (
              survey[key] &&
              survey[key].toString().toLowerCase().indexOf(word.toLowerCase()) >
                -1
            ) {
              containsSearch = true;
              return;
            }
          });
        });
        if (!containsSearch) return false; // Survey does not match search string

        keys.forEach((key) => {
          if (!containsSearch) return;

          if (
            (!survey[key] && this.filters[key]) ||
            (survey[key] &&
              survey[key]
                .toString()
                .toLowerCase()
                .indexOf(this.filters[key].toLowerCase()) < 0)
          ) {
            containsSearch = false; // Survey does not match filterstring
            return;
          }
        });
        return containsSearch;
      };

      this.filteredSurveyListData = !_.isEmpty(
        this.allSurveyInstancesAnswersData
      )
        ? this.allSurveyInstancesAnswersData.filter(surveyFilter)
        : [];
      this.currentSort.asc = !this.currentSort.asc;
      if (!keepPage) this.updatePaging(1, 0);
      this.orderTableCell(this.currentSort.key);
    },
    numberOfPages() {
      if (this.pageSize == -1) return 1;
      if (this.filteredSurveyListData.length % this.pageSize == 0)
        return this.filteredSurveyListData.length / this.pageSize;
      else
        return parseInt(this.filteredSurveyListData.length / this.pageSize) + 1;
    },
    // Updates the current pagesize and the selected pagenumber and triggers the refresh of the table
    updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber;
      if (pageSize != 0) this.pageSize = pageSize;
      this.loadCurrentPageOfSurveys();
    },
    // Returns a range of numbers with min-value, max-value and stepsize
    getRange(min, max, step) {
      var range = [],
        j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },
    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages() {
      if (this.numberOfPages() <= 7) {
        return this.getRange(1, this.numberOfPages(), 1);
      } else if (this.numberOfPages() > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (
        this.numberOfPages() > 7 &&
        this.selectedPage >= this.numberOfPages() - 3
      ) {
        return this.getRange(this.numberOfPages() - 5, this.numberOfPages(), 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },
    loadCurrentPageOfSurveys() {
      if (this.pageSize === -1)
        this.surveysOnCurrentPage = this.filteredSurveyListData;
      else {
        this.surveysOnCurrentPage = [];
        var startIndex = (this.selectedPage - 1) * this.pageSize;
        for (var i = startIndex; i < startIndex + this.pageSize; i++) {
          if (this.filteredSurveyListData[i] != null)
            this.surveysOnCurrentPage[i - startIndex] =
              this.filteredSurveyListData[i];
        }
      }
      if (
        _.findIndex(this.surveysOnCurrentPage, {
          SurveyInstanceId: this.selectedSurveyInstanceId,
        }) < 0
      ) {
        this.selectedSurveyInstanceId = -1;
        this.selectedSurveyInstance = null;
      }
    },
    surveyListStatusFilterSelectOpened() {
      // Force with of status filter select to fit the content
      this.$nextTick(() => {
        $("#select2-surveyListStatusFilterSelect-results")
          .parent()
          .parent()
          .css("width", "fit-content");
      });
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this, this.setElementHeights);
      // We need to refresh the list of surveys, because there is the LocaleCode whose default
      // value (survey never saved) will depend on the current frontend language
      this.getAllSurveyInstancesAnswers();
    },
  },
};
</script>

<style>
#surveyListStatusFilterContainer > .select2.select2-container {
  margin: 2px 0 1px 0;
}
#surveyListStatusFilterContainer .select2-selection {
  background: transparent;
}
#surveyListStatusFilterContainer
  .select2-selection
  .select2-selection__rendered {
  text-align: center;
}
.table-space {
  display: block;
  overflow-x: auto;
}
</style>

<style scoped>
#materialIconCell > i {
  margin-top: 6px;
}

.material-icons.md-18 {
  font-size: 18px;
}

.material-icons.md-36 {
  font-size: 36px;
}

.autovalidationTable {
  max-height: 35vh;
  width: 100%;
  overflow-y: auto;
}

table.main-table {
  font-size: 14px;
}

.word-break {
  overflow-wrap: break-word;
}

@media (max-width: 1000px) {
  .material-icons.md-18 {
    font-size: 24px;
  }
  .material-icons.md-24 {
    font-size: 36px;
  }
  .material-icons.md-36 {
    font-size: 48px;
  }
  @media only screen and (hover: none) and (pointer: coarse) {
    table.main-table > thead > tr > th {
      font-size: 36px !important;
    }
    table.main-table {
      font-size: 30px;
    }
    .pagination-fonts {
      font-size: 32px;
    }
    .form-control {
      font-size: 32px !important;
    }
    .material-icons.md-18 {
      font-size: 36px;
    }
    .material-icons.md-24 {
      font-size: 48px;
    }
    .material-icons.md-36 {
      font-size: 72px;
    }
  }
  /* @media screen and (max-aspect-ratio: 13/9) {
    .material-icons.md-18 {
      font-size: 36px;
    }
    .material-icons.md-24 {
      font-size: 48px;
    }
    .material-icons.md-36 {
      font-size: 72px;
    }
  } */
}
</style>



// WEBPACK FOOTER //
// SurveyList.vue?77c2a03c